(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-heading"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-register"] && !Shopify.designMode) return;
  try {
    
(function () {
  var GMAIL_RE = /^[a-z0-9](\.?[a-z0-9_+-]){2,}@gmail\.com$/i;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var MOBILE_RE = /^[6-9]\d{9}$/;
  var GST_RE = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
  var PASS_RE = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var form = root.querySelector('form');
    var statusEl = form.querySelector('.pr__status');
    var gmailOnly = root.dataset.gmailOnly === 'true';
    var demo = root.dataset.demo === 'true';
    var verified = { mobile: false, email: false };
    var verifiedValue = { mobile: '', email: '' };
    var current = 1;

    function f(n) { return form.elements.namedItem(n); }

    function post(url, data) {
      if (demo) { // demo only: any 6 digits is accepted. NEVER use in production.
        return new Promise(function (r) { setTimeout(function () { r({ success: true }); }, 500); });
      }
      if (!url) return Promise.reject(new Error('Endpoint not configured'));
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).then(function (r) { return r.json(); });
    }

    function setErr(input, msg) {
      var fld = input.closest('.pr__field');
      fld.classList.toggle('is-error', !!msg);
      var el = fld.querySelector('.pr__err');
      if (el) el.textContent = msg || '';
    }

    /* ---------- Step navigation ---------- */
    function goTo(n) {
      current = n;
      form.querySelectorAll('.pr__step').forEach(function (s) {
        s.hidden = Number(s.dataset.step) !== n;
      });
      form.querySelectorAll('[data-dot]').forEach(function (d) {
        var i = Number(d.dataset.dot);
        d.classList.toggle('is-active', i === n);
        d.classList.toggle('is-done', i < n);
      });
      statusEl.textContent = '';
    }

    function updateNext() {
      form.querySelector('[data-step="1"] [data-next]').disabled = !verified.mobile;
      form.querySelector('[data-step="2"] [data-next]').disabled = !verified.email;
    }

    form.querySelectorAll('[data-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (current === 1 && verified.mobile) goTo(2);
        else if (current === 2 && verified.email) goTo(3);
      });
    });
    form.querySelectorAll('[data-back]').forEach(function (b) {
      b.addEventListener('click', function () { if (current > 1) goTo(current - 1); });
    });

    /* ---------- OTP block (mobile + email) ---------- */
    function setupVerify(type, nextStep) {
      var box = form.querySelector('[data-verify="' + type + '"]');
      var input = f(type);
      var otpRow = box.querySelector('.pr__otp');
      var otpInput = otpRow.querySelector('input');
      var sendBtn = box.querySelector('[data-action=send]');
      var verifyBtn = box.querySelector('[data-action=verify]');
      var msg = box.querySelector('.pr__msg');
      var timer;

      function say(t, ok) { msg.textContent = t; msg.classList.toggle('ok', !!ok); }

      function validate() {
        var v = input.value.trim();
        if (type === 'mobile') return MOBILE_RE.test(v) ? '' : 'Enter a valid 10-digit mobile number';
        if (gmailOnly) return GMAIL_RE.test(v) ? '' : 'Enter a valid Gmail address (@gmail.com)';
        return EMAIL_RE.test(v) ? '' : 'Enter a valid email address';
      }

      function countdown(sec) {
        clearInterval(timer);
        sendBtn.disabled = true;
        timer = setInterval(function () {
          sec--;
          if (sec <= 0) { clearInterval(timer); sendBtn.disabled = false; sendBtn.textContent = 'Resend OTP'; }
          else sendBtn.textContent = 'Resend in ' + sec + 's';
        }, 1000);
        sendBtn.textContent = 'Resend in ' + sec + 's';
      }

      input.addEventListener('input', function () {
        if (type === 'mobile') input.value = input.value.replace(/\D/g, '');
        if (verified[type] && input.value.trim() !== verifiedValue[type]) {
          verified[type] = false; say('Please verify again'); otpRow.hidden = true;
          sendBtn.hidden = false; sendBtn.disabled = false; sendBtn.textContent = 'Send OTP';
          updateNext();
        }
      });

      sendBtn.addEventListener('click', function () {
        var e = validate();
        if (e) { say(e); return; }
        sendBtn.disabled = true; say('Sending OTP…', true);
        var payload = {}; payload[type] = input.value.trim();
        post(root.dataset[type === 'mobile' ? 'sendMobile' : 'sendEmail'], payload)
          .then(function (res) {
            if (res && res.success) {
              otpRow.hidden = false; otpInput.value = ''; otpInput.focus();
              say('OTP sent to ' + (type === 'mobile' ? '+91 ' : '') + input.value.trim(), true);
              countdown(30);
            } else { sendBtn.disabled = false; say((res && res.message) || 'Could not send OTP'); }
          })
          .catch(function (err) { sendBtn.disabled = false; say(err.message || 'Network error'); });
      });

      verifyBtn.addEventListener('click', function () {
        var code = otpInput.value.trim();
        if (!/^\d{6}$/.test(code)) { say('Enter the 6-digit OTP'); return; }
        verifyBtn.disabled = true;
        var payload = { otp: code }; payload[type] = input.value.trim();
        post(root.dataset[type === 'mobile' ? 'verifyMobile' : 'verifyEmail'], payload)
          .then(function (res) {
            verifyBtn.disabled = false;
            if (res && res.success) {
              verified[type] = true; verifiedValue[type] = input.value.trim();
              otpRow.hidden = true; sendBtn.hidden = true; clearInterval(timer);
              say('✓ ' + (type === 'mobile' ? 'Mobile' : 'Email') + ' verified', true);
              updateNext();
              setTimeout(function () { if (verified[type] && current === nextStep - 1) goTo(nextStep); }, 700);
            } else say((res && res.message) || 'Invalid OTP');
          })
          .catch(function (err) { verifyBtn.disabled = false; say(err.message || 'Network error'); });
      });
    }

    setupVerify('mobile', 2);
    setupVerify('email', 3);

    /* ---------- Step 3 ---------- */
    ['name', 'brand', 'password', 'confirm_password'].forEach(function (n) {
      f(n).addEventListener('input', function () { setErr(f(n), ''); });
    });
    f('gst').addEventListener('input', function () { f('gst').value = f('gst').value.toUpperCase(); setErr(f('gst'), ''); });
    var termsErr = form.querySelector('[data-terms-err]');
    f('terms').addEventListener('change', function () { termsErr.textContent = ''; });

    form.querySelectorAll('[data-eye]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = b.parentNode.querySelector('input');
        var show = inp.type === 'password';
        inp.type = show ? 'text' : 'password';
        b.textContent = show ? 'Hide' : 'Show';
      });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!verified.mobile) { goTo(1); return; }
      if (!verified.email) { goTo(2); return; }

      var bad = false;
      if (!f('name').value.trim()) { setErr(f('name'), 'Name is required'); bad = true; }
      if (!f('brand').value.trim()) { setErr(f('brand'), 'Brand name is required'); bad = true; }
      if (f('gst').value && !GST_RE.test(f('gst').value)) { setErr(f('gst'), 'Invalid GST number'); bad = true; }
      if (!PASS_RE.test(f('password').value)) { setErr(f('password'), 'Min 8 characters with letters and numbers'); bad = true; }
      if (f('confirm_password').value !== f('password').value || !f('confirm_password').value) {
        setErr(f('confirm_password'), 'Passwords do not match'); bad = true;
      }
      if (!f('terms').checked) { termsErr.textContent = 'Please accept the Terms & Conditions'; bad = true; }
      if (bad) return;

      var submitBtn = form.querySelector('button[type=submit]');
      submitBtn.disabled = true; statusEl.style.color = '#535766'; statusEl.textContent = 'Submitting…';
      post(root.dataset.submit, {
        mobile: f('mobile').value.trim(),
        email: f('email').value.trim(),
        name: f('name').value.trim(),
        brand: f('brand').value.trim(),
        gst: f('gst').value.trim(),
        password: f('password').value,
        confirm_password: f('confirm_password').value
      }).then(function (res) {
        submitBtn.disabled = false;
        if (res && res.success) {
          statusEl.style.color = '#03a685'; statusEl.textContent = 'Registration successful!';
          form.reset();
          verified.mobile = verified.email = false;
          form.querySelectorAll('.pr__msg').forEach(function (m) { m.textContent = ''; });
          form.querySelectorAll('[data-action=send]').forEach(function (b) { b.hidden = false; b.disabled = false; b.textContent = 'Send OTP'; });
          updateNext();
          if (res.redirect) window.location.href = res.redirect;
          else setTimeout(function () { goTo(1); statusEl.textContent = 'Registration successful!'; }, 1200);
        } else { statusEl.style.color = '#d0021b'; statusEl.textContent = (res && res.message) || 'Registration failed'; }
      }).catch(function (err) {
        submitBtn.disabled = false; statusEl.style.color = '#d0021b'; statusEl.textContent = err.message || 'Network error';
      });
    });
  }

  function boot() { document.querySelectorAll('.pr').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RE = {
    mobile: [/^[6-9]\d{9}$/, 'Enter a valid 10-digit mobile number starting with 6–9.'],
    email:  [/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, 'Enter a valid email address'],
    pin:    [/^[1-9]\d{5}$/, 'Enter a valid 6-digit pincode'],
    gst:    [/^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/, 'Enter a valid 15-character GSTIN'],
    gstopt: [/^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/, 'Enter a valid 15-character GSTIN'],
    ifsc:   [/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter a valid IFSC (e.g. HDFC0001234)'],
    acc:    [/^\d{9,18}$/, 'Enter a valid account number (9–18 digits)']
  };
  var STATES = {'01':'JAMMU & KASHMIR','02':'HIMACHAL PRADESH','03':'PUNJAB','04':'CHANDIGARH','05':'UTTARAKHAND','06':'HARYANA','07':'DELHI','08':'RAJASTHAN','09':'UTTAR PRADESH','10':'BIHAR','11':'SIKKIM','12':'ARUNACHAL PRADESH','13':'NAGALAND','14':'MANIPUR','15':'MIZORAM','16':'TRIPURA','17':'MEGHALAYA','18':'ASSAM','19':'WEST BENGAL','20':'JHARKHAND','21':'ODISHA','22':'CHHATTISGARH','23':'MADHYA PRADESH','24':'GUJARAT','25':'DAMAN & DIU','26':'DADRA & NAGAR HAVELI AND DAMAN & DIU','27':'MAHARASHTRA','29':'KARNATAKA','30':'GOA','31':'LAKSHADWEEP','32':'KERALA','33':'TAMIL NADU','34':'PUDUCHERRY','35':'ANDAMAN & NICOBAR','36':'TELANGANA','37':'ANDHRA PRADESH','38':'LADAKH'};
  var ENTITY = {P:'PROPRIETORSHIP',C:'COMPANY',F:'PARTNERSHIP',H:'HUF',A:'AOP',B:'BOI',G:'GOVERNMENT',J:'ARTIFICIAL JURIDICAL PERSON',L:'LOCAL AUTHORITY',T:'TRUST'};
  var TABS = ['gstin', 'basic', 'business', 'warehouse', 'bank', 'brand', 'declaration'];

  function gstOk(g) { // format + checksum
    if (!RE.gst[0].test(g)) return false;
    var c = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', s = 0, i, v;
    for (i = 0; i < 14; i++) { v = c.indexOf(g[i]) * (i % 2 ? 2 : 1); s += Math.floor(v / 36) + (v % 36); }
    return c[(36 - (s % 36)) % 36] === g[14];
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var URL_ = root.dataset.url, TOKEN = root.dataset.token;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
    var st = { appId: null, cur: 0, max: 0, done: {}, files: {}, gstChecked: '' };

    try { st.appId = localStorage.getItem('pf_app'); } catch (e) {}
    if (!st.appId) {
      st.appId = 'APP-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
      try { localStorage.setItem('pf_app', st.appId); } catch (e) {}
    }

    /* ---------- helpers ---------- */
    var toastT;
    function toast(msg, bad) {
      var t = $('#pf-toast'); t.textContent = msg; t.classList.toggle('bad', !!bad); t.classList.add('show');
      clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 3200);
    }
    function api(action, payload) {
      if (!URL_) return Promise.reject(new Error('Apps Script URL is not set in the Theme Editor'));
      var body = Object.assign({ token: TOKEN, action: action, appId: st.appId }, payload || {});
      // no custom headers => "simple" request, no CORS pre-flight with Apps Script
      return fetch(URL_, { method: 'POST', body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (!j.ok) throw new Error(j.error || 'Server error'); return j; });
    }
    function showErr(g, msg) {
      if (!g) return;
      var e = g.querySelector('.pf-err');
      if (!e) { e = document.createElement('p'); e.className = 'pf-err'; g.appendChild(e); }
      e.textContent = msg || ''; g.classList.toggle('has-err', !!msg);
    }
    function groupOf(el) { return el.closest('.form-group') || el.closest('.cell') || el.closest('.declaration-box') || el.parentNode; }

    /* ---------- data collect / fill ---------- */
    function list(sel) {
      return $$(sel).map(function (p) {
        var o = {}; $$('[data-f]', p).forEach(function (el) { o[el.dataset.f] = el.value.trim(); }); return o;
      });
    }
    function collect() {
      var d = {};
      $$('.main-content [name]').forEach(function (el) {
        if (el.type === 'file') return;
        if (el.type === 'radio') { if (el.checked) d[el.name] = el.value; else if (!(el.name in d)) d[el.name] = ''; }
        else if (el.type === 'checkbox') d[el.name] = el.checked;
        else d[el.name] = el.value.trim();
      });
      return d;
    }
    function payload() {
      return { data: collect(), warehouses: list('.wh-panel'), brands: list('.brand-card'), files: st.files, max: st.max, done: st.done };
    }
    function fill(d) {
      $$('.main-content [name]').forEach(function (el) {
        if (!(el.name in d) || el.type === 'file') return;
        if (el.type === 'radio') { el.checked = el.value === d[el.name]; if (el.checked) $('#' + (el.name === 'business_model' ? 'bm' : 'oms') + '-trigger').textContent = el.value; }
        else if (el.type === 'checkbox') el.checked = d[el.name] === true || d[el.name] === 'true';
        else el.value = d[el.name];
      });
    }
    function showFileLabels() {
      Object.keys(st.files).forEach(function (k) {
        var inp = $('[data-file="' + k + '"]'); if (!inp) return;
        var lab = inp.parentElement.querySelector('.file-upload-label span, .file-field');
        if (lab) lab.textContent = 'Uploaded ✓';
      });
    }

    /* ---------- validation ---------- */
    function checkEl(el) {
      var v = el.type === 'checkbox' ? el.checked : el.value.trim(), msg = '';
      var k = el.dataset.v, test = v;
      if (el.hasAttribute('data-req') && !v) msg = el.type === 'checkbox' ? 'Please accept to continue' : 'This field is required';
      else if (v && k && RE[k] && !RE[k][0].test(el.dataset.upper !== undefined ? String(v).toUpperCase() : test)) msg = RE[k][1];
      showErr(groupOf(el), msg);
      return !msg;
    }
    function validateTab(t) {
      var pane = $('#tab-' + t), ok = true, first = null;
      function bad(el) { ok = false; if (!first) first = el; }
      $$('[data-req],[data-v]', pane).forEach(function (el) {
        if (el.closest('.wh-panel') === null && el.closest('.brand-card') === null && el.closest('[hidden]')) return; // skip hidden gst block
        if (!checkEl(el)) bad(el);
      });
      if (t === 'gstin') {
        var g = $('[name=gstin]').value.trim().toUpperCase();
        if (st.gstChecked !== g || !g) { showErr(groupOf($('[name=gstin]')), 'Please click VERIFY for your GSTIN'); bad($('[name=gstin]')); }
      }
      if (t === 'business') {
        [['business_model', 'bm'], ['oms_type', 'oms']].forEach(function (p) {
          var okSel = !!$('[name=' + p[0] + ']:checked'); showErr($('[data-cs="' + p[1] + '"]'), okSel ? '' : 'This field is required');
          if (!okSel) bad($('#' + p[1] + '-trigger'));
        });
      }
      if (t === 'bank') {
        var fg = $('[data-filegroup="cancelled_cheque"]'), has = !!st.files.cancelled_cheque;
        showErr(fg, has ? '' : 'Please upload a cancelled cheque'); if (!has) bad(fg);
      }
      if (t === 'brand') {
        var n = $$('.brand-card').length; $('#brand-err').textContent = n ? '' : 'Select the number of brands and click Proceed';
        if (!n) bad($('#brand-count'));
      }
      if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return ok;
    }

    /* ---------- navigation ---------- */
    function refreshProgress() {
      var n = TABS.filter(function (t) { return st.done[t]; }).length, p = Math.round(n / TABS.length * 100);
      $('#pf-pct').textContent = p + '% Complete'; $('#pf-fill').style.width = p + '%';
      $$('.nav-item[data-tab]').forEach(function (a, i) {
        a.classList.toggle('done', !!st.done[TABS[i]]);
        a.classList.toggle('locked', i > st.max);
      });
    }
    function go(i) {
      st.cur = i;
      $$('.tab-section').forEach(function (s) { s.classList.remove('active'); });
      $('#tab-' + TABS[i]).classList.add('active');
      $$('.nav-item[data-tab]').forEach(function (a, k) { a.classList.toggle('active', k === i); });
      $('#btn-back').hidden = i === 0;
      $('#btn-next').hidden = i === TABS.length - 1;
      $('#btn-submit').hidden = i !== TABS.length - 1;
      $('#pf-footer').hidden = false;
      refreshProgress(); updateSubmit();
      if (root.dataset.started) window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
    }
    function updateSubmit() { $('#btn-submit').disabled = !($('#decl1').checked && $('#decl2').checked); }

    $$('.nav-item[data-tab]').forEach(function (a, i) {
      a.addEventListener('click', function (e) { e.preventDefault(); if (i <= st.max) go(i); else toast('Please complete the previous step first', true); });
    });
    $('#btn-back').addEventListener('click', function () { if (st.cur > 0) go(st.cur - 1); });
    $('#btn-next').addEventListener('click', function () {
      var t = TABS[st.cur];
      if (!validateTab(t)) { toast('Please fix the highlighted fields', true); return; }
      st.done[t] = true; st.max = Math.max(st.max, st.cur + 1);
      api('save', payload()).catch(function (e) { toast('Could not save: ' + e.message, true); });
      go(st.cur + 1);
    });
    $('#btn-save').addEventListener('click', function () {
      var b = this; b.disabled = true;
      api('save', payload()).then(function () { toast('Progress saved. You can resume later on this device.'); })
        .catch(function (e) { toast(e.message, true); }).then(function () { b.disabled = false; });
    });
    $('#decl1').addEventListener('change', updateSubmit);
    $('#decl2').addEventListener('change', updateSubmit);

    $('#btn-submit').addEventListener('click', function () {
      for (var i = 0; i < TABS.length; i++) {
        if (!validateTab(TABS[i])) { go(i); toast('Please complete this section first', true); return; }
        st.done[TABS[i]] = true;
      }
      st.max = TABS.length - 1;
      var b = this; b.disabled = true; b.textContent = 'Submitting…';
      api('submit', payload()).then(function () {
        refreshProgress();
        $$('.tab-section').forEach(function (s) { s.classList.remove('active'); });
        $('#tab-success').classList.add('active'); $('#success-id').textContent = st.appId;
        $('#pf-footer').hidden = true;
        try { localStorage.removeItem('pf_app'); } catch (e) {}
      }).catch(function (e) { toast(e.message, true); b.disabled = false; b.textContent = 'SUBMIT'; });
    });

    /* ---------- GSTIN verify ---------- */
    $('#btn-gst').addEventListener('click', function () {
      var inp = $('[name=gstin]'), g = inp.value.trim().toUpperCase();
      if (!gstOk(g)) { showErr(groupOf(inp), 'Invalid GSTIN. Please check and try again.'); return; }
      showErr(groupOf(inp), ''); st.gstChecked = g;
      var pan = g.substr(2, 10);
      $('[name=pan]').value = pan;
      $('[name=state]').value = STATES[g.substr(0, 2)] || '';
      $('[name=entity_type]').value = ENTITY[pan[3]] || '';
      $('#gst-echo').value = g;
      $('#gst-details').hidden = false;
      toast('GSTIN verified. Please confirm the business details below.');
    });
    $('[name=gstin]').addEventListener('input', function () { st.gstChecked = ''; });

    /* ---------- delegated events ---------- */
    root.addEventListener('input', function (e) {
      var el = e.target;
      if (el.dataset && el.dataset.upper !== undefined) el.value = el.value.toUpperCase();
      if (el.dataset && (el.dataset.v === 'mobile' || el.dataset.v === 'pin' || el.dataset.v === 'acc')) el.value = el.value.replace(/\D/g, '');
      if (el.classList && (el.classList.contains('form-input') || el.classList.contains('form-select') || el.classList.contains('gst-input'))) showErr(groupOf(el), '');
    });
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches && el.matches('[data-req],[data-v]') && el.type !== 'file') { if (el.value || el.type === 'checkbox') showErr(groupOf(el), ''); }
      // pincode -> city/state (free India Post API; ignored if it fails)
      var gstinPin = el.name === 'pincode', whPin = el.dataset && el.dataset.f === 'pincode';
      if ((gstinPin || whPin) && RE.pin[0].test(el.value)) {
        var scope = whPin ? el.closest('.wh-panel') : $('#tab-gstin');
        fetch('https://api.postalpincode.in/pincode/' + el.value).then(function (r) { return r.json(); }).then(function (j) {
          var o = j && j[0] && j[0].PostOffice && j[0].PostOffice[0]; if (!o) return;
          var city = scope.querySelector(whPin ? '[data-f=city]' : '[name=city]'), state = scope.querySelector(whPin ? '[data-f=state]' : '[name=state]');
          if (city && !city.value) city.value = o.District || o.Division || '';
          if (state && (whPin ? !state.value : false)) state.value = o.State || '';
        }).catch(function () {});
      }
      // file upload -> Google Drive
      if (el.type === 'file' && el.dataset.file) uploadFile(el);
    });

    function uploadFile(inp) {
      var f = inp.files[0], key = inp.dataset.file; if (!f) return;
      var lab = inp.parentElement.querySelector('.file-upload-label span, .file-field');
      if (f.size > 5 * 1024 * 1024) { toast('File must be under 5 MB', true); inp.value = ''; return; }
      if (['application/pdf', 'image/jpeg', 'image/png'].indexOf(f.type) < 0) { toast('Only PDF, JPG or PNG allowed', true); inp.value = ''; return; }
      lab.textContent = 'Uploading…';
      var r = new FileReader();
      r.onload = function () {
        api('upload', { field: key, fileName: f.name, mimeType: f.type, data: String(r.result).split(',')[1] })
          .then(function (res) { st.files[key] = res.url; lab.textContent = f.name + ' ✓'; showErr(groupOf(inp), ''); })
          .catch(function (e) { lab.textContent = 'Choose a file...'; toast('Upload failed: ' + e.message, true); inp.value = ''; });
      };
      r.readAsDataURL(f);
    }

    /* ---------- custom radio dropdowns ---------- */
    function customSelect(tid, did) {
      var t = $('#' + tid), d = $('#' + did);
      t.addEventListener('click', function (e) { e.stopPropagation(); t.classList.toggle('open'); d.classList.toggle('open'); });
      $$('input[type=radio]', d).forEach(function (r) {
        r.addEventListener('change', function () {
          t.textContent = r.value; t.classList.remove('open'); d.classList.remove('open'); showErr(groupOf(t), '');
        });
      });
    }
    customSelect('bm-trigger', 'bm-dropdown'); customSelect('oms-trigger', 'oms-dropdown');
    document.addEventListener('click', function () {
      $$('.custom-select-trigger').forEach(function (t) { t.classList.remove('open'); });
      $$('.custom-select-dropdown').forEach(function (d) { d.classList.remove('open'); });
    });

    /* ---------- bank verify (IFSC lookup) ---------- */
    $('#btn-bank').addEventListener('click', function () {
      var ok = ['acc_holder', 'acc_no', 'ifsc'].map(function (n) { return checkEl($('[name=' + n + ']')); }).every(Boolean);
      if (!ok) return;
      var ifsc = $('[name=ifsc]').value;
      fetch('https://ifsc.razorpay.com/' + ifsc).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
        if (!$('[name=bank_name]').value) $('[name=bank_name]').value = j.BANK;
        toast('IFSC verified: ' + j.BANK + ', ' + j.BRANCH);
      }).catch(function () { showErr(groupOf($('[name=ifsc]')), 'IFSC not found. Please check it.'); });
    });

    /* ---------- warehouses ---------- */
    var whWrap = $('#wh-panels'), whBar = $('#wh-tabs'), whActive = 0;
    function renderWh() {
      var panels = $$('.wh-panel', whWrap);
      whActive = Math.min(whActive, panels.length - 1);
      panels.forEach(function (p, i) { p.classList.toggle('on', i === whActive); });
      whBar.innerHTML = '';
      panels.forEach(function (p, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'wh-tab' + (i === whActive ? ' active' : '');
        b.textContent = 'Warehouse ' + (i + 1); b.onclick = function () { whActive = i; renderWh(); }; whBar.appendChild(b);
      });
      var add = document.createElement('button'); add.type = 'button'; add.className = 'wh-tab-add';
      add.innerHTML = '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> ADD Warehouse';
      add.onclick = function () { addWh(); whActive = $$('.wh-panel', whWrap).length - 1; renderWh(); };
      whBar.appendChild(add);
    }
    function addWh(data) {
      var p = $('#wh-tpl').content.firstElementChild.cloneNode(true);
      if (data) $$('[data-f]', p).forEach(function (el) { if (data[el.dataset.f] !== undefined && data[el.dataset.f] !== '') el.value = data[el.dataset.f]; });
      $('[data-wh-del]', p).onclick = function () {
        if ($$('.wh-panel', whWrap).length < 2) { toast('At least one warehouse is required', true); return; }
        p.remove(); whActive = 0; renderWh();
      };
      $('[data-wh-verify]', p).onclick = function () {
        var g = $('[data-f=gstin]', p), v = g.value.trim().toUpperCase();
        if (!v) { showErr(groupOf(g), 'Enter the warehouse GSTIN'); return; }
        if (gstOk(v)) { showErr(groupOf(g), ''); toast('Warehouse GSTIN verified'); } else showErr(groupOf(g), 'Invalid GSTIN');
      };
      whWrap.appendChild(p);
    }

    /* ---------- brands ---------- */
    function buildBrands(n, keep) {
      var box = $('#brand-list'); box.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var c = $('#brand-tpl').content.firstElementChild.cloneNode(true);
        $('.brand-title', c).textContent = 'Brand ' + (i + 1);
        if (keep && keep[i]) $$('[data-f]', c).forEach(function (el) { if (keep[i][el.dataset.f]) el.value = keep[i][el.dataset.f]; });
        box.appendChild(c);
      }
    }
    $('#btn-proceed').addEventListener('click', function () {
      var n = parseInt($('#brand-count').value, 10);
      if (!n) { $('#brand-err').textContent = 'Please select the number of brands'; return; }
      $('#brand-err').textContent = ''; buildBrands(n, list('.brand-card'));
    });

    /* ---------- init + resume ---------- */
    addWh(); renderWh(); go(0); $('#pf-footer').hidden = false; root.dataset.started = '1';

    function prefill() { // optional: values saved by your registration page
      var q = new URLSearchParams(location.search), reg = {};
      try { reg = JSON.parse(localStorage.getItem('pf_reg') || '{}'); } catch (e) {}
      var map = { org_email: q.get('email') || reg.email, contact_phone: q.get('mobile') || reg.mobile, contact_name: q.get('name') || reg.name };
      Object.keys(map).forEach(function (k) { var el = $('[name=' + k + ']'); if (el && !el.value && map[k]) el.value = map[k]; });
    }

    api('load').then(function (res) {
      if (!res.found || !res.draft) return;
      if (res.status === 'Submitted') {
        $$('.tab-section').forEach(function (s) { s.classList.remove('active'); });
        $('#tab-success').classList.add('active'); $('#success-id').textContent = st.appId; $('#pf-footer').hidden = true; return;
      }
      var d = res.draft;
      fill(d.data || {});
      st.files = d.files || {}; st.done = d.done || {}; st.max = d.max || 0;
      whWrap.innerHTML = ''; (d.warehouses && d.warehouses.length ? d.warehouses : [{}]).forEach(addWh); renderWh();
      if (d.brands && d.brands.length) { $('#brand-count').value = String(d.brands.length); buildBrands(d.brands.length, d.brands); }
      var g = (d.data && d.data.gstin || '').toUpperCase();
      if (st.done.gstin && gstOk(g)) { st.gstChecked = g; $('#gst-echo').value = g; $('#gst-details').hidden = false; }
      showFileLabels(); go(Math.min(st.max, TABS.length - 1));
      toast('Welcome back! Your saved progress was restored.');
    }).catch(function () {}).then(prefill);
  }

  function boot() { document.querySelectorAll('.pf').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
